module.exports = __webpack_public_path__ + "img/pic_xiyiningzhu1.4df6c246.png";